import { SyntheticEvent } from 'react';
import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import './SignUp.css'





const SignUp = () => {
  
  let navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();


    const response = await fetch("https://api-j06q.onrender.com/api/user/register", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        name,
        password
      })
    })

    const data = await response.json();
    //console.log(data);
    if (!response.ok) {
      setError(data.error)
    }
    //console.log(response.ok);
    //console.log(data.error);
    
    
    if (response.ok) {
      setError(null)
      //localStorage.setItem('user', JSON.stringify(data))
      

      navigate('/login')
    }
  }

  
  

    return (
      <div className='SignUp-Container'>
        <form onSubmit={handleSubmit}>
          <img className='loginLogo' src='./images/loginLogo.png' alt='logo' />
          <h1 className='SignUp-Title'>Register</h1>
          <input
            type="name"
            value={name}
            onChange={e => setName(e.target.value)}
            name="name"
            placeholder="Your Name"
            required
          />
          <br />
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            name="email"
            placeholder="john.doe@gmail.com"
            required
          />
          <br />
          <input
            type="password"
            className="form-control mb-4 p-4"
            value={password}
            onChange={e => setPassword(e.target.value)}
            name="password"
            placeholder="********"
            required
          />
          <br />
          <button className='signup-button'>Register</button>
          {error && <div className="error">{error}</div>}
          <h3 className='linkName'>Already a member! <a className='Login-Link' href='/login'>Login</a></h3>
        </form>
      
      </div>
    )
  
}

export default SignUp;
